import React from 'react';
export function FlatTree({
  className = ''
}: {
  className?: string;
}) {
  return <svg width="220" height="260" viewBox="0 0 220 260" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-68">
      {/* Background Glow */}
      <circle cx="110" cy="110" r="100" fill="rgba(197,216,45,0.06)" data-id="element-69" />

      {/* Trunk */}
      <rect x="100" y="150" width="20" height="90" rx="4" fill="#5D4037" data-id="element-70" />
      <path d="M100 230 Q 90 240 85 240 L 135 240 Q 130 240 120 230 Z" fill="#5D4037" data-id="element-71" />

      {/* Branches */}
      <path d="M110 180 L 80 140" stroke="#5D4037" strokeWidth="8" strokeLinecap="round" data-id="element-72" />
      <path d="M110 160 L 145 120" stroke="#5D4037" strokeWidth="7" strokeLinecap="round" data-id="element-73" />

      {/* Canopy Circles (Overlapping) */}
      <circle cx="110" cy="70" r="45" fill="#8FA320" data-id="element-74" />
      <circle cx="70" cy="110" r="40" fill="#C5D82D" data-id="element-75" />
      <circle cx="150" cy="100" r="42" fill="#A8BF24" data-id="element-76" />
      <circle cx="90" cy="145" r="35" fill="#B5C828" data-id="element-77" />
      <circle cx="135" cy="140" r="38" fill="#D4E54A" data-id="element-78" />
      <circle cx="110" cy="110" r="45" fill="#9DB225" data-id="element-79" />
    </svg>;
}